import styled from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import media from "@irati/ui/src/global/media"
import {IconButton} from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"

export default styled(Card)`
  margin-top: 50px;
  ${media.tablet`margin-top: 40px;`}
  position: relative;
  ${IconButton} {
    position: absolute;
    top: ${padding.small};
    left: ${padding.small};
  }
`
